// M1 限定: plain dictionary lookup の自前 wrapper。
// M3 で UI 実装に着手するタイミングで複数形・補間が必要になれば
// @formatjs/intl 等への置換を検討する (置換コストを抑えるため公開 API は最小)。

// 注: import attributes (`with { type: 'json' }`) は Wrangler 3 系 esbuild が未対応のため使わない。
// tsconfig.base.json の resolveJsonModule で型解決される。
import en from './locales/en.json';
import ja from './locales/ja.json';

const dict = { ja, en } as const;

export type Locale = keyof typeof dict;
export type MessageKey = keyof typeof ja;

export const SUPPORTED_LOCALES: readonly Locale[] = ['ja', 'en'] as const;
export const DEFAULT_LOCALE: Locale = 'ja';

export function t(key: MessageKey, locale: Locale = DEFAULT_LOCALE): string {
  return dict[locale][key] ?? dict[DEFAULT_LOCALE][key];
}
